import React from 'react';
import { Drawer, Typography } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { useTeamAssistantTheme } from '../../context/TeamAssistantThemeContext';
import { TEAM_ASSISTANT_OVERLAY_Z_INDEX } from '../../utils/teamAssistantZIndex';
import './team-assistant-color-theme-modal.css';

const { Text } = Typography;

const DRAWER_WIDTH = 400;

const TeamAssistantColorThemeModal = ({ open, onClose }) => {
  const { themeId, setThemeId, themes } = useTeamAssistantTheme();

  return (
    <Drawer
      title="Chat appearance"
      placement="right"
      open={open}
      onClose={onClose}
      width={DRAWER_WIDTH}
      maskClosable
      destroyOnClose={false}
      zIndex={TEAM_ASSISTANT_OVERLAY_Z_INDEX}
      className="team-assistant-color-theme-drawer"
      rootClassName="team-assistant-color-theme-drawer-root"
      styles={{
        body: { paddingTop: 8 },
        header: { borderBottomColor: 'var(--ta-header-border, #ececf1)' },
      }}
    >
      <Text type="secondary" className="team-assistant-color-theme-drawer-intro">
        Color schemes apply to the Team Assistant page and mini assistant. Click outside or close when
        you are done.
      </Text>

      <h3 className="team-assistant-color-theme-section-title team-assistant-color-theme-section-title--colors">
        Color scheme
      </h3>
      <div className="team-assistant-color-theme-grid" role="list">
        {themes.map((theme) => {
          const active = theme.id === themeId;
          return (
            <button
              key={theme.id}
              type="button"
              role="listitem"
              className={`team-assistant-color-theme-card${active ? ' is-active' : ''}`}
              onClick={() => {
                setThemeId(theme.id);
              }}
              aria-pressed={active}
              aria-label={`${theme.label}. ${theme.description}`}
            >
              <span className="team-assistant-color-theme-card-head">
                <span className="team-assistant-color-theme-card-label">{theme.label}</span>
                {active && (
                  <CheckOutlined className="team-assistant-color-theme-card-check" aria-hidden />
                )}
              </span>
              <span className="team-assistant-color-theme-swatches" aria-hidden>
                {theme.swatches.map((color) => (
                  <span
                    key={color}
                    className="team-assistant-color-theme-swatch"
                    style={{ background: color }}
                    title={color}
                  />
                ))}
              </span>
              <span className="team-assistant-color-theme-card-desc">{theme.description}</span>
            </button>
          );
        })}
      </div>
    </Drawer>
  );
};

export default TeamAssistantColorThemeModal;
